import { IStateProvider } from 'angular-ui-router';

import { SdcStateBuilder } from './sdc-state-builder.service';

GradPlanningRouteConfig.$inject = ['$stateProvider'];

const SDC_KEY = 'grad-planning';

export function GradPlanningRouteConfig($stateProvider: IStateProvider) {
  const gradPlanningGridState = SdcStateBuilder.buildGridState(SDC_KEY);
  const gradPlanningWizardState = SdcStateBuilder.builGradPlanningWizardState(SDC_KEY);
  const gradPlanningProfileState = SdcStateBuilder.buildProfileState(SDC_KEY);

  $stateProvider

    .state(`main.school.new-sdc.${SDC_KEY}`, {
      abstract: true,
      url: `/${SDC_KEY}`,
      template: `
      <sdc-root
      current-user="$resolve.currentUser"
      current-state="$resolve.currentState">
      </sdc-root>
        `,
    })

    .state(`main.school.new-sdc.${SDC_KEY}.grid`, gradPlanningGridState)
    .state(`main.school.new-sdc.${SDC_KEY}.wizard`, gradPlanningWizardState)
    .state(`main.school.new-sdc.${SDC_KEY}.profile`, gradPlanningProfileState);
}
